import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { appConfig } from "../config";

let client: SupabaseClient | undefined;

export function getSupabaseClient(): SupabaseClient {
  client ??= createClient(appConfig.supabaseUrl, appConfig.publishableKey, {
    auth: {
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true,
    },
  });
  return client;
}
